<template>
  <div
    class="escape-presenting"
    @click.stop="handleBacktoEditor()"
  >
    <div
      class="escape-presenting __wrapper"
      :class="{'light-text': slideActive.textColour === '#ffffff' && !isPreview}"
      @mouseover="handleMouseOver()"
      @mouseleave="handleMouseLeave()"
    >
      <aha-icon
        name="arrow-tail"
        viewBox="0 0 18 19"
        width="21"
        height="22"
      />
    </div>
    <div class="tooltip-escape" v-show="showTooltip">
      <div
        class="tooltip-text"
        :class="{
          'is-not-preview' : !isPreview
        }"
      >
        {{ $i18nPresenter.t('Back to Editor') }}
      </div>
      <div
        class="tooltip__tip"
        :class="{
          'is-not-preview': !isPreview
        }"
      ></div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import utils from '@/util'
import SlideApi from '@/api/slide'
import PresentationApi from '@/api/presentation'
import constants from '@/constant'
import Socket from '@/socket'
import Sentry from '@/services/sentry'
import eventCategories from '@/constant/eventCategories'
import EventBus from '@/eventBus'

export default {
  data() {
    return {
      showTooltip: false,
    }
  },
  computed: {
    ...mapState({
      presentation: (state) => state.presentation,
      slideActive: (state) => state.slideActive,
      isAdmin: (state) => state.isAdmin,
      sharePresentation: (state) => state.sharePresentation,
      isPreview: (state) => state.isPreview,
    }),
    conditionsUpdateLastSlide() {
      return this.presentation.id && !this.isAdmin && !this.sharePresentation
    },
  },
  methods: {
    ...mapActions(['setSyncLoadingAction', 'toggleQRCodePanelAction']),
    handleBacktoEditor() {
      if (this.isPreview) {
        this.$emit('exitPreviewMode')
        return
      }

      // stop presenting
      utils.setCurrentWindowMode()
      this.$router.replace({
        name: 'PresentationDetail',
        params: { id: this.presentation.id },
      })
      if (this.slideActive.type == 'pickAnswer' && !this.isAdmin) {
        this._updateSlideQuizStatus()
      }

      if (this.conditionsUpdateLastSlide) {
        this._updatePresentationLastSlide()
      }
      utils.mixpanelTracking(
        eventCategories.PRESENTING_MODE,
        'Stop presenting button > Stop presenting',
      )
      EventBus.$emit('close-backstage-window')
      this.toggleQRCodePanelAction(false)
    },
    handleMouseOver() {
      this.showTooltip = true
    },
    handleMouseLeave() {
      this.showTooltip = false
    },
    async _updateSlideQuizStatus() {
      try {
        await SlideApi.updateSlideById(this.slideActive.id, {
          quizStatus: constants.QuizStatuses.LOBBY_SCREEN,
          socketId: Socket.getSocketId(),
          accessCode: this.presentation.uniqueAccessCode,
          activeSlide: this.slideActive.id,
          presentationId: this.presentation.id,
          presenting: false,
        })
      } catch (error) {
        this.setSyncLoadingAction(3)
      }
    },

    _getPayloadUpdatePresentationLastSlide() {
      const idLastSlide = utils.getLastSlide(
        this.$store.state.presentation.slides,
      )
      const payload = {
        presenting: false,
        socketId: Socket.getSocketId(),
        activeSlidePreseting: this.slideActive.id,
        activeSlideAccessCode: this.presentation.uniqueAccessCode,
      }
      if (idLastSlide && idLastSlide != this.presentation.lastSlide) {
        payload.lastSlide = idLastSlide
        this.presentation.lastSlide = idLastSlide
      }
      return payload
    },

    async _updatePresentationLastSlide() {
      try {
        const payload = this._getPayloadUpdatePresentationLastSlide()
        await PresentationApi.updatePresentationByPresentationId(this.presentation.id, payload)
      } catch (error) {
        Sentry.captureException(error)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.escape-presenting {
  position: absolute;
  cursor: pointer;
  top: 0.25rem;
  left: 0.5rem;
  font-size: 1.4rem;
  z-index: 135;
  opacity: 0;
  transition: all 0.3s ease;
  &.__wrapper {
    @apply rounded-full flex items-center justify-center w-10 h-10 bg-base-30 hover:bg-base-40;
    backdrop-filter: blur(44px);
    &.light-text {
      background-color: rgba(0, 0, 0, 0.36);
    }
    &:hover.light-text {
      background-color: rgba(0, 0, 0, 0.5);
    }
  }
}
.tooltip-escape {
  transition: opacity 0.2s ease;
  .tooltip-text {
    background-color: #282e3e;
    color: #ffffff;
    text-align: center;
    border-radius: 4px;
    padding-top: 0.35rem;
    padding-bottom: 0.35rem;
    padding-right: 0.5rem;
    padding-left: 0.5rem;
    font-size: 12px;
    position: absolute;
    font-family: "Rubik", sans-serif;
    font-style: normal;
    font-weight: 400;
    top: 3.5rem;
    &.is-not-preview {
      position: relative;
      top: 3.25rem;
    }
  }

  .tooltip__tip {
    position: absolute;
    left: 2.5rem;
    width: 7px;
    height: 7px;
    z-index: 10;
    font-size: 14px;
    background: #282E3E;
    transform: translate(-50%, 0) rotate(45deg);
    border-bottom-right-radius: 2px;
    outline: none;
    &.is-not-preview {
      position: relative;
      width: 11px !important;
      height: 11px !important;
      top: 1.25rem;
      right: calc(50% - 11px) !important;
    }
  }
}
</style>
